import React, { FunctionComponent } from 'react';
import { FontIcon, FontIcons, HoverTooltip, TooltipLooks } from '@brandfolder/react';
import classes from './styles/view_only_icon.module.scss';

export const ViewOnlyIcon: FunctionComponent = () => {
  return (
    <HoverTooltip
      className={classes['bf-tooltip']}
      look={TooltipLooks.Primary}
      text={bfTranslate('View Only')}
    >
      <FontIcon
        aria-hidden={false}
        aria-label={bfTranslate('View Only' )}
        className={classes['view-only-circle']}
        icon={FontIcons.Show}
        iconSize={20}
      />
    </HoverTooltip>
  );
};
